import { BoostedOddsRequestService } from '@bto-services/api/shared/boosted-odds-request-service';
import BoostedOddModel from 'bto-models/boosted-odd/boosted-odd.model';

/**
 * Vuex store - Boosted odds module
 */
export const boostedOddsModule = {
  state: {
    boostedOdds: [],
    initialBoostedOdds: [],
    sports: [],
    initialBoostedOddsFlag: false,
    asyncFlagBoosted: false,
    loading: false,
  },
  mutations: {
    /**
     * Update async call flag
     * @param state current store state
     * @param flagValue true|false
     */
    updateAsyncFlagBoosted(state, flagValue) {
      state.asyncFlagBoosted = flagValue;
    },
    /**
     * Update initialBoostedOddsFlag
     * @param state current store state
     * @param flagValue true|false
     */
    updateinitialBoostedOddsFlag(state, flagValue) {
      state.initialBoostedOddsFlag = flagValue;
    },
    /**
     * Update boosted odds state
     * @param data array of boosted odds/sports
     */
    updateBoostedOdds(state, data) {
      if (!data) {
        state.boostedOdds = [];
        return;
      }
      state.boostedOdds = data.odds;
    },
    /**
     * Update initial boosted odds state
     * @param data array of boosted odds/sports
     */
    updateInitialBoostedOdds(state, data) {
      if (!data) {
        state.initialBoostedOdds = [];
        return;
      }
      state.initialBoostedOdds = data.odds;
      state.sports = data.sports;
    },
    /**
     * Update loading status
     * @param state current store state
     * @param data true|false
     */
    updateLoadingStatus(state, data) {
      state.loading = data;
    },
  },
  actions: {
    /**
     * Get player markets
     * @param commit
     * @param state
     * @param sports
     * @param categories
     * @param categoryGroups
     * @param tournaments
     * @param tournamentGroups
     * @param matches
     * @param onlyBanner
     */
    getBoostedOdds({ commit, state }, { sports, categories, categoryGroups, tournaments, tournamentGroups, matches, onlyBanner = false }) {
      commit('updateLoadingStatus', true);
      // if already waiting for results
      if (state.asyncFlagBoosted) {
        return;
      }
      // notify that async call is about to start
      commit('updateAsyncFlagBoosted', true);

      // get boosted odds data
      let boostedOddsService = new BoostedOddsRequestService();
      boostedOddsService.getParams.Sports = sports;
      boostedOddsService.getParams.Categories = categories;
      boostedOddsService.getParams.CategoryGroups = categoryGroups;
      boostedOddsService.getParams.Tournaments = tournaments;
      boostedOddsService.getParams.TournamentGroups = tournamentGroups;
      boostedOddsService.getParams.Matches = matches;
      boostedOddsService.getParams.OnlyBanner = onlyBanner;

      boostedOddsService.execute((resp) => {
        commit('updateAsyncFlagBoosted', false);

        if (resp && resp.data) {
          const boostedModel = new BoostedOddModel(resp.data);

          // We need to update the intial boosted odds & sports only on start
          if(!state.initialBoostedOddsFlag){
            commit('updateInitialBoostedOdds', boostedModel);
            commit('updateinitialBoostedOddsFlag', true);
          }
          commit('updateBoostedOdds', boostedModel)
          
        }
        commit('updateLoadingStatus', false);
        
      }, () => {
        commit('updateAsyncFlagBoosted', false);
        commit('updateLoadingStatus', false);
      });
    },
  },
  getters: {
    getInitialBoostedOdds(state) {
      return state.initialBoostedOdds || [];
    },
    getBoostedOdds(state) {
      return state.boostedOdds || [];
    },
    getBoostedSports(state) {
      return state.sports || [];
    },
  },
};
